// extracted by mini-css-extract-plugin
export default {"container":"EventFeedbackTable_container__fYTnJ","table":"EventFeedbackTable_table__F2zxt","boundedCell":"EventFeedbackTable_boundedCell__pQdiT"};